import type {
  GetDocumentsVersionsDataRequestType,
  GetDocumentsVersionsDataResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const getDocumentsVersionsData = async (
  queryParams: GetDocumentsVersionsDataRequestType,
) => {
  const url = `/api/v2/documents/${queryParams.documentId}/versions/${queryParams.versionId}`;
  const response =
    await apiAuthClient.get<GetDocumentsVersionsDataResponseType>(url);

  return response.data;
};
